import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const AuthPage = ({ onLogin }) => {
    const [isRegister, setIsRegister] = useState(false);
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [message, setMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setMessage('');

        const endpoint = isRegister ? 'register' : 'login';
        const url = `${process.env.REACT_APP_BACKEND_URL}/api/auth/${endpoint}`;

        try {
            const response = await fetch(url, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email, password }),
            });
            const data = await response.json();

            if (response.ok) {
                if (isRegister) {
                    setMessage('Registration successful! Please log in.');
                    setIsRegister(false); // Switch to login form
                } else {
                    // Successful login
                    onLogin(data.token); // Pass token up to App.js
                }
            } else {
                setMessage(data.error || 'An error occurred.');
            }
        } catch (error) {
            setMessage('Could not connect to the server.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-darkBg text-white flex items-center justify-center p-6 overflow-hidden">
            <motion.div
                initial={{ opacity: 0, y: -50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7 }}
                className="glass-card glow-border w-full max-w-md p-8 rounded-2xl"
            >
                <h1 className="text-4xl font-extrabold text-center mb-4 text-neonPink custom-glow-text">
                    {isRegister ? 'Create Account' : 'Welcome Back'}
                </h1>
                <p className="text-center text-gray-400 mb-8">
                    {isRegister ? 'Join PiWatch to monitor your world.' : 'Log in to access your dashboard.'}
                </p>

                <form onSubmit={handleSubmit} className="flex flex-col gap-6">
                    <input
                        type="email"
                        placeholder="Email Address"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        className="p-3 bg-gray-800 rounded-lg border border-gray-700 focus:outline-none focus:border-neonBlue transition-colors"
                    />
                    <input
                        type="password"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        className="p-3 bg-gray-800 rounded-lg border border-gray-700 focus:outline-none focus:border-neonBlue transition-colors"
                    />
                    <button
                        type="submit"
                        disabled={isLoading}
                        className="bg-neonBlue text-black py-3 rounded-lg font-bold text-lg hover:bg-neonPink hover:scale-105 transition-all duration-300 disabled:bg-gray-600"
                    >
                        {isLoading ? 'Processing...' : (isRegister ? 'Register' : 'Log In')}
                    </button>
                </form>

                <AnimatePresence>
                    {message && (
                        <motion.p
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            className="text-center text-yellow-300 mt-6"
                        >
                            {message}
                        </motion.p>
                    )}
                </AnimatePresence>

                <p className="text-center text-gray-400 mt-8">
                    {isRegister ? 'Already have an account?' : "Don't have an account?"}
                    <button onClick={() => setIsRegister(!isRegister)} className="font-bold text-neonBlue ml-2 hover:underline">
                        {isRegister ? 'Log In' : 'Register'}
                    </button>
                </p>
            </motion.div>
        </div>
    );
};

export default AuthPage;
